import { PromptReviewOptions } from "./types";

const promptReview = async (options: PromptReviewOptions = {}) => {};
export default promptReview;
